import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Musicisti from "./components/Musicisti";
import Discografia from "./components/Discografia";
import Concerti from "./components/Concerti";
import Galleria from "./components/Galleria";
import Contatti from "./components/Contatti";
import Footer from "./components/Footer";

const HomePage = () => (
  <>
    <Navbar />
    <main data-testid="page-home">
      <Hero />
      <About />
      <Musicisti />
      <Discografia />
      <Concerti />
      <Galleria />
      <Contatti />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-[#0A0A0A] min-h-screen">
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#111111",
              border: "1px solid rgba(212, 175, 55, 0.4)",
              color: "#FDFBF7",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
